// Map defaults
export const DEFAULT_MAP_CENTER = {
  lat: 55.3843628,
  lng: 10.2577383,
} as const;

export const DEFAULT_ZOOM = 7;
export const MIN_ZOOM = 5;
export const MAX_ZOOM = 20;
export const MARKER_MIN_ZOOM = 7;

// Debounce delays (in milliseconds)
export const FILTER_DEBOUNCE_MS = 700;
export const SEARCH_DEBOUNCE_MS = 700;
export const SHARE_DEBOUNCE_MS = 700;

// Charge speed thresholds (in kW)
export const SLOW_MAX_KW = 22;
export const FAST_MIN_KW = 23;
export const FAST_MAX_KW = 99;
export const ULTRA_FAST_MIN_KW = 100;

// Cluster thresholds
export const CLUSTER_THRESHOLDS = [1, 10, 20, 50, 100, 500] as const;

// Responsive breakpoint
export const DESKTOP_BREAKPOINT = 800;

// Storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'monta_access_token',
  REFRESH_TOKEN: 'monta_refresh_token',
  SESSION_ID: 'monta_session_id',
  SESSION_UUID: 'monta_session_uuid',
  LANGUAGE: 'monta_language',
  IP_LOCATION: 'monta_ip_location',
} as const;

// IP location cache duration (7 days in milliseconds)
export const IP_LOCATION_CACHE_DURATION = 7 * 24 * 60 * 60 * 1000;
